module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/anli_Star_gray.48c2d.png";